export default __webpack_public_path__ + "static/cambridge-b046745d92262365fbe5139db5e768c4.svg";